import React, { Component } from 'react';
import { connect } from 'react-redux';
import { logoutUser } from '../../actions/user';

class AppHeader extends Component {
  render() {
    return (
          <div dangerouslySetInnerHTML={{__html: this.props.myheadermenu }} />				
	);
	  
}
}
export default connect(
  (state) => ({
    token: state.token,
    firstname: state.user && state.user.firstname ? state.user && state.user.firstname : 'Profile',
    email:state.user && state.user.email     
  }),
  { logoutUser }
)(AppHeader);



// WEBPACK FOOTER //
// ./src/components/app-header/index.js